import Emitter from "./Emitter";

export default class ResultsShown extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default(data) {
        if (data) {
            this.emitTop({ wpgaction: "RESULTS_SHOWN", data:data });
            this.emitParent({ wpgaction: "RESULTS_SHOWN", data:data });
            this.emitiOS({ wpgaction: "RESULTS_SHOWN", data:data });
        } else {
            this.emitTop({ wpgaction: "RESULTS_SHOWN"});
            this.emitParent({ wpgaction: "RESULTS_SHOWN"});
            this.emitiOS({ wpgaction: "RESULTS_SHOWN"});
        }
    }
}